import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import axiosInstance from "../services/axiosInstance";

const instance = axiosInstance();
async function unsubscribe_user(email) {
  const response = await instance.post("/unsubscribe/", { email });
  return response.data; 
}
  
function Unsubscribe() {
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false); // State to handle loading

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (name.trim()) {
      setLoading(true); // Start loading state
      const result = await unsubscribe_user(name);
      setMessage(result.message);
      setLoading(false); // End loading state
      setName("");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">
        <h1 className="text-3xl font-bold mb-6 text-center text-primary">Unsubscribe</h1>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="space-y-2">
            <Label htmlFor="name" className="text-gray-700">
              Your Email
            </Label>
            <Input
              id="email"
              type="text"
              placeholder="Enter your email"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
            />
          </div>
          <Button
            type="submit"
            className="w-full bg-primary hover:bg-primary-dark text-white font-bold py-2 px-4 rounded-md transition duration-300 ease-in-out"
            disabled={loading} // Disable button when loading
          >
            {loading ? "Unsubscribing..." : "Unsubscribe"}
          </Button>
          {message && (
            <p
              className={`text-sm text-center mt-4 p-3 rounded-md ${
                message.includes("not found") ? "text-red-600 bg-red-100" : "text-green-600 bg-green-100"
              }`}
            >
              {message}
            </p>
          )}
        </form>
      </div>
    </div>
  );
}

export default Unsubscribe;
